import {
  ADD_PRODUCT_ITEM, DECREASE_PRODUCT_QUANTITY, DELETE_PRODUCT_ITEM,
  INCREASE_PRODUCT_QUANTITY, RESET_PRODUCT_QUANTITY
} from './actionTypes';

export const addProductItem = item => {
  return {
    type: ADD_PRODUCT_ITEM,
    payload: {
      productId: Date.now(),
      ...item,
    },
  };
};
export const deleteProductItem = itemId => {
  return {
    type: DELETE_PRODUCT_ITEM,
    payload: itemId,
  };
};
export const increaseProductQuantity = itemId => {
  return {
    type: INCREASE_PRODUCT_QUANTITY,
    payload: itemId,
  };
};
export const decreaseProductQuantity = itemId => {
  return {
    type: DECREASE_PRODUCT_QUANTITY,
    payload: itemId,
  };
};
export const resetProductQuantity = itemId => {
  return {
    type: RESET_PRODUCT_QUANTITY,
    payload: itemId,
  };
};
